import React from 'react';

/*
 *  @Description:   Stateless component that renders an X.
 */

const Delete = ( props ) => {

    return (<g id="path">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
        </g>
    )
};

export default Delete;

